export function isNotEmptyObject(obj) {
  return Boolean(Object.keys(obj || {})[0]);
}
